import { render, staticRenderFns } from "./ViolationReject.vue?vue&type=template&id=59ae5004&"
import script from "./ViolationReject.vue?vue&type=script&lang=ts&"
export * from "./ViolationReject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports